const payToYandexLink = (userId, payId, sum, nickname) => {

  const card = '4100117653838324'

  return `https://yoomoney.ru/quickpay/confirm.xml?receiver=${card}&short-dest=${userId}&label=${payId}&quickpay-form=donate&targets=${nickname}&sum=${sum.toFixed(1)}&paymentType=AC`
}

export default payToYandexLink
